"use client"

import ContactForm from "./ContactForm";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import "./ContactUs.css";

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: <FaPhone />,
      title: "WhatsApp",
      info: "+1 (346) 464-9730",
      action: () => (window.location.href = "tel:+13464649730"),
    },
    {
      icon: <FaEnvelope />,
      title: "Email",
      info: "info@shipmentsolutionsllc.com",
      action: () => (window.location.href = "mailto:info@shipmentsolutionsllc.com"),
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Head Office",
      info: "Katy, Texas, USA",
      action: () => window.open("https://maps.google.com/?q=Katy+Texas+USA", "_blank"),
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Branch Office",
      info: "127-1081, Nishinoyacho, Naka-ku, Yokohama, Japan",
      action: () => window.open("https://maps.google.com/?q=127-1081+Nishinoyacho+Naka-ku+Yokohama+Japan", "_blank"),
    },
    {
      icon: <FaClock />,
      title: "Business Hours",
      info: "Open 24/7",
      action: null,
    },
  ];

  return (
    <div className="contact-info-section">
      <h3 className="contact-info-title">Contact Information</h3>
      <div className="contact-info-grid">
        {contactDetails.map((detail, index) => (
          <div
            key={index}
            className={`contact-info-card ${detail.action ? "clickable" : ""}`}
            onClick={detail.action}
          >
            <div className="contact-info-icon">{detail.icon}</div>
            <div className="contact-info-content">
              <h4 className="contact-info-card-title">{detail.title}</h4>
              <p className="contact-info-text">{detail.info}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function ContactUs() {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Contact Us</h1>
          <p className="contact-hero-subtitle">
            We'd love to hear from you. Get in touch with us for any questions, support, or business inquiries.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-main-content">
        {/* Contact Form */}
        <div className="contact-form-wrapper">
          <ContactForm />
        </div>

        {/* Contact Information */}
        <ContactInfo />

        {/* Map Section */}
        <div className="map-section">
          <h3 className="map-title">Find Us</h3>
          
          {/* Head Office Map */}
          <div className="map-container">
            <h4>Head Office</h4>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3487.1828527002693!2d-95.82451678450516!3d29.785785781958246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864126f503131ecb%3A0x6ffba4aa4d9dd9be!2sKaty%2C%20TX%2077494%2C%20USA!5e0!3m2!1sen!2sus!4v1719779000000"
              className="map-iframe"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Head Office Location"
            ></iframe>
          </div>

          {/* Branch Office Map */}
          <div className="map-container">
            <h4>Branch Office - Japan</h4>
            <iframe
              src="https://www.google.com/maps?q=127-1081+Nishinoyacho+Naka-ku+Yokohama+Japan&output=embed"
              className="map-iframe"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Japan Branch Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
